export default __webpack_public_path__ + "static/media/meal-plate.511ea58b.png";